/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Status of a match group
 * @export
 */
export const MatchGroupStatus = {
    AiSuggested: 'ai_suggested',
    UserConfirmed: 'user_confirmed',
    Rejected: 'rejected'
} as const;
export type MatchGroupStatus = typeof MatchGroupStatus[keyof typeof MatchGroupStatus];


export function instanceOfMatchGroupStatus(value: any): boolean {
    for (const key in MatchGroupStatus) {
        if (Object.prototype.hasOwnProperty.call(MatchGroupStatus, key)) {
            if (MatchGroupStatus[key as keyof typeof MatchGroupStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MatchGroupStatusFromJSON(json: any): MatchGroupStatus {
    return MatchGroupStatusFromJSONTyped(json, false);
}

export function MatchGroupStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchGroupStatus {
    return json as MatchGroupStatus;
}

export function MatchGroupStatusToJSON(value?: MatchGroupStatus | null): any {
    return value as any;
}

export function MatchGroupStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): MatchGroupStatus {
    return value as MatchGroupStatus;
}

